import { type VariantProps, cva } from "class-variance-authority";
import { cn } from "../lib/utils";
import { Icon, type IconSymbol } from "./icon";

const boxSymbolVariants = cva(
  "inline-flex items-center justify-center font-semibold",
  {
    variants: {
      size: {
        sm: "h-5.5 w-5.5 rounded text-xs",
        md: "h-6 w-6 rounded-md text-sm",
        lg: "h-7 w-7 rounded-lg text-xl",
        xl: "h-7.5 w-7.5 rounded-full text-xl",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);

export interface BoxSymbolProps extends VariantProps<typeof boxSymbolVariants> {
  symbol: number | IconSymbol;
  bgColorClassName?: string;
  textColorClassName?: string;
  className?: string;
}

export const BoxSymbol: React.FC<BoxSymbolProps> = ({
  symbol,
  size = "md",
  bgColorClassName = "bg-gray-100",
  textColorClassName = "text-gray-900",
  className,
}) => {
  const isNumber = typeof symbol === "number";

  // Size to icon size mapping
  const iconSizeMap = {
    sm: 14,
    md: 16,
    lg: 24,
    xl: 24,
  };

  const iconSize = iconSizeMap[size || "md"];

  return (
    <div
      className={cn(
        boxSymbolVariants({ size }),
        bgColorClassName,
        textColorClassName,
        className,
      )}
    >
      {isNumber ? (
        <span>{symbol}</span>
      ) : (
        <Icon icon={symbol} size={iconSize} />
      )}
    </div>
  );
};

export default BoxSymbol;
